// Comprehensive list of world languages with native names and codes
export const LANGUAGES = [
    // Major Global Languages
    { code: "en", name: "English", nativeName: "English" },
    { code: "zh", name: "Chinese", nativeName: "中文" },
    { code: "hi", name: "Hindi", nativeName: "हिन्दी" },
    { code: "es", name: "Spanish", nativeName: "Español" },
    { code: "fr", name: "French", nativeName: "Français" },
    { code: "ar", name: "Arabic", nativeName: "العربية" },
    { code: "pt", name: "Portuguese", nativeName: "Português" },
    { code: "ru", name: "Russian", nativeName: "Русский" },
    { code: "ja", name: "Japanese", nativeName: "日本語" },
    { code: "de", name: "German", nativeName: "Deutsch" },
    { code: "ko", name: "Korean", nativeName: "한국어" },
    { code: "it", name: "Italian", nativeName: "Italiano" },
    { code: "tr", name: "Turkish", nativeName: "Türkçe" },
    { code: "pl", name: "Polish", nativeName: "Polski" },
    { code: "nl", name: "Dutch", nativeName: "Nederlands" },
    { code: "sv", name: "Swedish", nativeName: "Svenska" },
    { code: "da", name: "Danish", nativeName: "Dansk" },
    { code: "no", name: "Norwegian", nativeName: "Norsk" },
    { code: "fi", name: "Finnish", nativeName: "Suomi" },
    { code: "el", name: "Greek", nativeName: "Ελληνικά" },
    { code: "he", name: "Hebrew", nativeName: "עברית" },
    { code: "th", name: "Thai", nativeName: "ไทย" },
    { code: "vi", name: "Vietnamese", nativeName: "Tiếng Việt" },
    { code: "id", name: "Indonesian", nativeName: "Bahasa Indonesia" },
    { code: "ms", name: "Malay", nativeName: "Bahasa Melayu" },
    { code: "tl", name: "Filipino", nativeName: "Filipino" },
    { code: "bn", name: "Bengali", nativeName: "বাংলা" },
    { code: "ur", name: "Urdu", nativeName: "اردو" },
    { code: "fa", name: "Persian", nativeName: "فارسی" },
    { code: "ta", name: "Tamil", nativeName: "தமிழ்" },
    { code: "te", name: "Telugu", nativeName: "తెలుగు" },
    { code: "ml", name: "Malayalam", nativeName: "മലയാളം" },
    { code: "kn", name: "Kannada", nativeName: "ಕನ್ನಡ" },
    { code: "gu", name: "Gujarati", nativeName: "ગુજરાતી" },
    { code: "pa", name: "Punjabi", nativeName: "ਪੰਜਾਬੀ" },
    { code: "mr", name: "Marathi", nativeName: "मराठी" },
    { code: "ne", name: "Nepali", nativeName: "नेपाली" },
    { code: "si", name: "Sinhala", nativeName: "සිංහල" },
    { code: "my", name: "Burmese", nativeName: "မြန်မာ" },
    { code: "km", name: "Khmer", nativeName: "ខ្មែរ" },
    { code: "lo", name: "Lao", nativeName: "ລາວ" },
    { code: "ka", name: "Georgian", nativeName: "ქართული" },
    { code: "am", name: "Amharic", nativeName: "አማርኛ" },
    { code: "sw", name: "Swahili", nativeName: "Kiswahili" },
    { code: "zu", name: "Zulu", nativeName: "IsiZulu" },
    { code: "af", name: "Afrikaans", nativeName: "Afrikaans" },
    { code: "sq", name: "Albanian", nativeName: "Shqip" },
    { code: "az", name: "Azerbaijani", nativeName: "Azərbaycan" },
    { code: "be", name: "Belarusian", nativeName: "Беларуская" },
    { code: "bg", name: "Bulgarian", nativeName: "Български" },
    { code: "hr", name: "Croatian", nativeName: "Hrvatski" },
    { code: "cs", name: "Czech", nativeName: "Čeština" },
    { code: "et", name: "Estonian", nativeName: "Eesti" },
    { code: "hu", name: "Hungarian", nativeName: "Magyar" },
    { code: "is", name: "Icelandic", nativeName: "Íslenska" },
    { code: "ga", name: "Irish", nativeName: "Gaeilge" },
    { code: "lv", name: "Latvian", nativeName: "Latviešu" },
    { code: "lt", name: "Lithuanian", nativeName: "Lietuvių" },
    { code: "mk", name: "Macedonian", nativeName: "Македонски" },
    { code: "mt", name: "Maltese", nativeName: "Malti" },
    { code: "ro", name: "Romanian", nativeName: "Română" },
    { code: "sk", name: "Slovak", nativeName: "Slovenčina" },
    { code: "sl", name: "Slovenian", nativeName: "Slovenščina" },
    { code: "uk", name: "Ukrainian", nativeName: "Українська" },
    { code: "eu", name: "Basque", nativeName: "Euskera" },
    { code: "ca", name: "Catalan", nativeName: "Català" },
    { code: "gl", name: "Galician", nativeName: "Galego" },
    { code: "cy", name: "Welsh", nativeName: "Cymraeg" },
    { code: "is", name: "Icelandic", nativeName: "Íslenska" },
    { code: "fo", name: "Faroese", nativeName: "Føroyskt" },
    { code: "lb", name: "Luxembourgish", nativeName: "Lëtzebuergesch" },
    { code: "rm", name: "Romansh", nativeName: "Rumantsch" },
    { code: "yi", name: "Yiddish", nativeName: "ייִדיש" },
    { code: "kk", name: "Kazakh", nativeName: "Қазақша" },
    { code: "ky", name: "Kyrgyz", nativeName: "Кыргызча" },
    { code: "uz", name: "Uzbek", nativeName: "O'zbek" },
    { code: "tg", name: "Tajik", nativeName: "Тоҷикӣ" },
    { code: "mn", name: "Mongolian", nativeName: "Монгол" },
    { code: "bo", name: "Tibetan", nativeName: "བོད་ཡིག" },
    { code: "dz", name: "Dzongkha", nativeName: "རྫོང་ཁ" },
    { code: "hy", name: "Armenian", nativeName: "Հայերեն" },
    { code: "az", name: "Azerbaijani", nativeName: "Azərbaycan" },
    { code: "tk", name: "Turkmen", nativeName: "Türkmen" },
    { code: "ug", name: "Uyghur", nativeName: "ئۇيغۇرچە" },
    { code: "cv", name: "Chuvash", nativeName: "Чӑваш" },
    { code: "tt", name: "Tatar", nativeName: "Татар" },
    { code: "ba", name: "Bashkir", nativeName: "Башҡорт" },
    { code: "ce", name: "Chechen", nativeName: "Нохчийн" },
    { code: "os", name: "Ossetian", nativeName: "Ирон" },
    { code: "kbd", name: "Kabardian", nativeName: "Адыгэбзэ" },
    { code: "ady", name: "Adyghe", nativeName: "Адыгабзэ" },
    { code: "av", name: "Avar", nativeName: "Авар" },
    { code: "lez", name: "Lezghian", nativeName: "Лезги" },
    { code: "lbe", name: "Lak", nativeName: "Лакку" },
    { code: "dar", name: "Dargwa", nativeName: "Дарган" },
    { code: "inh", name: "Ingush", nativeName: "ГӀалгӀай" },
    { code: "xmf", name: "Mingrelian", nativeName: "მარგალური" },
    { code: "lzz", name: "Laz", nativeName: "ლაზური" },
    { code: "sva", name: "Svan", nativeName: "ლუშნუ" },
    { code: "bua", name: "Buryat", nativeName: "Буряад" },
    { code: "xal", name: "Kalmyk", nativeName: "Хальмг" },
    { code: "tyv", name: "Tuvan", nativeName: "Тыва" },
    { code: "kjh", name: "Khakas", nativeName: "Хакас" },
    { code: "chv", name: "Chuvash", nativeName: "Чӑваш" },
    { code: "udm", name: "Udmurt", nativeName: "Удмурт" },
    { code: "kv", name: "Komi", nativeName: "Коми" },
    { code: "myv", name: "Erzya", nativeName: "Эрзянь" },
    { code: "mdf", name: "Moksha", nativeName: "Мокшень" },
    { code: "sah", name: "Sakha", nativeName: "Саха" },
    { code: "ckt", name: "Chukchi", nativeName: "Ԓыгъоравэтԓьэн" },
    { code: "ykg", name: "Yukaghir", nativeName: "Юкагир" },
    { code: "kpy", name: "Koryak", nativeName: "Нымылан" },
    { code: "itl", name: "Itelmen", nativeName: "Итәнмән" },
    { code: "nio", name: "Nganasan", nativeName: "Нганасан" },
    { code: "sel", name: "Selkup", nativeName: "Шӧльӄумыт" },
    { code: "ket", name: "Ket", nativeName: "Остыганна ӄа" },
    { code: "yug", name: "Yug", nativeName: "Юг" },
    { code: "kca", name: "Khanty", nativeName: "Ханты" },
    { code: "mns", name: "Mansi", nativeName: "Манси" },
    { code: "sjd", name: "Kildin Sami", nativeName: "Кӣллт са̄мь кӣлл" },
    { code: "sje", name: "Pite Sami", nativeName: "Bidumsámegiella" },
    { code: "smj", name: "Lule Sami", nativeName: "Julevsámegiella" },
    { code: "sme", name: "Northern Sami", nativeName: "Davvisámegiella" },
    { code: "smn", name: "Inari Sami", nativeName: "Anarâškielâ" },
    { code: "sms", name: "Skolt Sami", nativeName: "Nuõrttsääʹmǩiõll" },
    { code: "sju", name: "Ume Sami", nativeName: "Ubmejesámiengiälla" },
    { code: "sjd", name: "Kildin Sami", nativeName: "Кӣллт са̄мь кӣлл" },
    { code: "sje", name: "Pite Sami", nativeName: "Bidumsámegiella" },
    { code: "smj", name: "Lule Sami", nativeName: "Julevsámegiella" },
    { code: "sme", name: "Northern Sami", nativeName: "Davvisámegiella" },
    { code: "smn", name: "Inari Sami", nativeName: "Anarâškielâ" },
    { code: "sms", name: "Skolt Sami", nativeName: "Nuõrttsääʹmǩiõll" },
    { code: "sju", name: "Ume Sami", nativeName: "Ubmejesámiengiälla" },
];

// Function to get language by code
export const getLanguageByCode = (code) => {
    return LANGUAGES.find(lang => lang.code === code);
};

// Function to get language name for display
export const getLanguageDisplayName = (code) => {
    const language = getLanguageByCode(code);
    return language ? `${language.name} (${language.nativeName})` : code;
};

// Function to sort languages alphabetically
export const getSortedLanguages = () => {
    return [...LANGUAGES].sort((a, b) => a.name.localeCompare(b.name));
};
